'use strict'

export default (mockAxios) => {
  // ライセンス情報の取得
  mockAxios.onGet(`/licenses`).reply(200, {
    'success': true,
    'data': {
      'company_name': '株式会社ABC',
      'company_kana': 'かぶしきがいしゃえーびーしー',
      'company_code': '000000000000',
      'formatted_contract_count': '10,000',
      'formatted_bcard_usage': '570', // V2で追加
      'formatted_bcard_count': '56,780', // V2で追加
      'formatted_judgement_date': '2020/10/10',
      'contract_input': null
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/licenseSettingRepositoryMock.js